import React, { useEffect, useState } from "react";
import download from "../../assets/clarity_download-line.png";
import eye from "../../assets/eye.png";
import doc from "../../assets/lsicon_report-outline.png";
import close from "../../assets/closeIcon.png";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import SelectButtonV2 from "../../components/SelectButtonV2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MultiSelect from "./MultipleSelect";
import ManagerSelect from "../../components/Registration-details/ManagerSelect";
import SelectInvestor from "../../components/Bond/SelectInvestor";
import Repeater from "../../components/Bond/Repeater";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const BondListEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location?.state?.uniqueId;
  const [bondDetails, setBondDetails] = useState([]);
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [popular, setPopular] = useState("");
  const [highRated, setHighrated] = useState("");
  const [ytm, setYtm] = useState("");
  const [name, setName] = useState("");
  const [freq, setFreq] = useState("");
  const [minIvest, setMinInvest] = useState("");
  const [mat, setMat] = useState("");
  console.log("mini", minIvest, mat);
  const [secured, setSecured] = useState(false);
  const [senior, setSenior] = useState(false);
  const [listed, setListed] = useState(false);
  const [liquiedRisk, setLiquiedRisk] = useState(false);
  const [creditRisk, setCreditRisk] = useState(false);
  const [fraudRisk, setFraudRisk] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState();
  const [selectedPan, setSelectPanFile] = useState();
  const [previewPan, setPanPreview] = useState();
  const [selectedAadhar, setSelectAadharFile] = useState();
  const [previewAadhar, setPreviewAadhar] = useState();

  const [formData, setFormData] = useState({
    coupenRate: "",
    coupenFrequency: "",
    minInvestment: "",
    maturity: "",
    issuerName: "",
    issueType: "",
    coupenBasis: "",
    industry: "",
    faceValue: "",
    dateOfMaturity: "",
    isin: "",
    isinDescription: "",
    debantureTrustee: "",
    securityName: "",
    ratingAgency: "",
    rating: "",
    ratedOn: "",
    handPicked: false,
    popular: false,
    highRated: false,
    secured: false,
    senior: false,
    listed: false,
    liquidityRisk: false,
    creditRisk: false,
    fraudRisk: false,
    currentYeild: "",
    imDocument: null,
    bondDetailsDocument: null,
    logo: null,
  });

  // const {  } = useSelector((state) => state.);

  const [investorNameSelect, setInvestorNameSelect] = useState([]);
  // const [formData, setFormData] = useState({
  //   ...bondDetails,
  // });

  const [rows, setRows] = useState([]);

  const users = [
    { label: "Bipul", value: "bipul" },
    { label: "John", value: "john" },
    { label: "Alice", value: "alice" },
    { label: "Emma", value: "emma" },
    { label: "Ryan", value: "ryan" },
  ];

  const [files, setFiles] = useState({
    imDocument: null,
    bondDetailsDocument: null,
    logo: null,
  });

  const optionsShow = ["yes", "no"];

  console.log("bondDetails", bondDetails);

  const handleSelectOccupation = (value) => {
    setSelectedOccupation(value);
  };
  console.log("im", selectedPan, selectedAadhar, selectedFile, preview);

  const handleSelectPopular = (value) => {
    setPopular(value);
  };

  const handleSelectHighRated = (value) => {
    setHighrated(value);
  };

  const handlePImChange = (event) => {
    // handleClear();
    setPreview();
    const file = event.target.files[0];

    if (file) {
      // Set the selected file
      setSelectedFile(file);

      // Create file preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleBdChange = (event) => {
    // handleClear();
    setPanPreview();
    const file = event.target.files[0];

    if (file) {
      // Set the selected file
      setSelectPanFile(file);

      // Create file preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPanPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleLogoChange = (event) => {
    // handleClear();
    setPreviewAadhar();
    const file = event.target.files[0];

    if (file) {
      // Set the selected file
      setSelectAadharFile(file);

      // Create file preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewAadhar(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/bonds/${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      setBondDetails(response?.data?.data?.bond);
      const sellerUsers = response?.data?.data?.bondSellData || [];
      if (sellerUsers?.length > 0) {
        const transformed = sellerUsers?.map((su) => ({
          id: su.id || null, // assuming userId maps to your row's id
          name: "", // name will be filled later by suggestion fetch
          quantity: su.quantity || 1,
          bondId: su?.bondId,
          userId: su?.userId,
          suggestions: [],
        }));

        setRows(transformed);
      }

      console.log("bond seller details", response?.data?.data?.bondSellData);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const updateBondDetails = async () => {
    const endpoint = `${base_url}/${api_type}/bonds/${id}`;

    console.log("rows", rows);

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (!row.name || row.name.trim() === "") {
        toast.info(`Investor ${i + 1}: Name is required.`);
        return;
      }

      const quantity = parseInt(row.quantity, 10);
      if (!quantity || quantity < 1) {
        toast.info(`Investor ${i + 1}: Quantity must be at least 1.`);
        return;
      }
    }

    const formDatas = new FormData();
    formDatas.append("imDocumentFile", selectedFile || null);
    formDatas.append("imDocumentFile", selectedFile || null);
    formDatas.append("bondDetailsDocumentFile", selectedPan || null);
    formDatas.append("logoFile", selectedAadhar || null);
    formDatas.append("name", name);
    formDatas.append("imDocument", bondDetails?.imDocument);
    formDatas.append("bondDetailsDocument", bondDetails?.bondDetailsDocument);
    formDatas.append("logo", bondDetails?.logo);
    formDatas.append("coupenRate", formData?.coupenRate);
    formDatas.append("coupenFrequency", freq || formData?.coupenFrequency);
    formDatas.append("minInvestment", minIvest);
    formDatas.append("maturity", mat);
    formDatas.append("issuerName", formData?.issuerName);
    formDatas.append("issueType", formData?.issueType);
    formDatas.append("coupenBasis", formData?.coupenBasis);
    formDatas.append("industry", formData?.industry);
    formDatas.append("faceValue", formData?.faceValue);
    formDatas.append("dateOfMaturity", formData?.dateOfMaturity);
    formDatas.append("isin", formData?.isin);
    formDatas.append("debantureTrustee", formData?.debantureTrustee);
    formDatas.append("securityName", formData?.securityName);
    formDatas.append("ratingAgency", formData?.ratingAgency);
    formDatas.append("rating", formData?.rating);
    formDatas.append("ratedOn", formData?.ratedOn);
    formDatas.append("handPicked", formData?.handPicked);
    formDatas.append("popular", formData?.popular);
    formDatas.append("highRated", formData?.highRated);
    formDatas.append("secured", secured);
    formDatas.append("senior", senior);
    formDatas.append("listed", listed);
    formDatas.append("liquidityRisk", liquiedRisk);
    formDatas.append("creditRisk", creditRisk);
    formDatas.append("fraudRisk", fraudRisk);
    formDatas.append("currentYeild", formData?.currentYeild);
    formDatas.append("isinDescription", formData?.isinDescription);

    console.log("rowsrows", rows);
    if (rows?.length > 0) {
      rows?.forEach((row, index) => {
        // formDatas.append(`sellerUsers[${index}][id]`, row.id);
        formDatas.append(`sellerUsers[${index}][userId]`, row.userId);
        formDatas.append(`sellerUsers[${index}][bondId]`, id);
        formDatas.append(`sellerUsers[${index}][quantity]`, row.quantity);
      });
    }

    // return;

    try {
      const response = await axios.put(endpoint, formDatas, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      // setBondDetails(response?.data?.data?.bond);

      toast.success(response?.data?.message || "Bond updated successfully", {
        onClose: () => navigate("/bond"), // Replace '/success-page' with your desired path
        autoClose: 3000, // Automatically close after 3 seconds
      });
      setBondDetails([]);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
      toast.error(
        err.message || "Failed to update bond details. Please try again.",
        {
          onClose: () => navigate("/bond"),
          autoClose: 3000, // Automatically close after 5 seconds
        }
      );
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, []);
  useEffect(() => {
    if (bondDetails) {
      // Spread operator to copy all fields from bondDetails to formData
      setListed(bondDetails?.listed);
      // setSelectedFile(bondDetails?.imDocument)
      setName(bondDetails?.name);
      setFreq(bondDetails?.coupenFrequency);

      // setSelectPanFile(bondDetails?.bondDetailsDocument)
      // setSelectAadharFile(bondDetails?.logo)
      setYtm(bondDetails?.coupenRate);
      setMinInvest(bondDetails?.minInvestment);
      setMat(bondDetails?.maturity);
      setCreditRisk(bondDetails?.creditRisk);
      setFraudRisk(bondDetails?.fraudRisk);
      setHighrated(bondDetails?.highRated);
      setLiquiedRisk(bondDetails?.liquidityRisk);
      setSenior(bondDetails?.senior);
      setSecured(bondDetails?.secured);
      setFormData((prevFormData) => ({
        ...prevFormData,
        coupenRate: bondDetails?.coupenRate,
        coupenFrequency: bondDetails?.coupenFrequency,
        minInvestment: bondDetails?.minInvestment,
        maturity: bondDetails?.maturity,
        issuerName: bondDetails?.issuerName,
        issueType: bondDetails?.issueType,
        coupenBasis: bondDetails?.coupenBasis,
        industry: bondDetails?.industry,
        faceValue: bondDetails?.faceValue,
        dateOfMaturity: bondDetails?.dateOfMaturity,
        isin: bondDetails?.isin,
        debantureTrustee: bondDetails?.debantureTrustee,
        securityName: bondDetails?.securityName,
        ratingAgency: bondDetails?.ratingAgency,
        rating: bondDetails?.rating,
        ratedOn: bondDetails?.ratedOn,
        currentYeild: bondDetails?.currentYeild,

        // Ensure date fields are properly formatted
        dateOfMaturity: bondDetails.dateOfMaturity
          ? bondDetails.dateOfMaturity.split("T")[0]
          : "",
        ratedOn: bondDetails.ratedOn ? bondDetails.ratedOn.split("T")[0] : "",
        secured,
        listed,
        liquidityRisk: liquiedRisk,
        senior,
        fraudRisk,
        creditRisk,
        handPicked: bondDetails?.handPicked,
        popular: bondDetails?.popular,
        highRated: bondDetails?.highRated,
      }));
    }
  }, [bondDetails]);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  // Add this validation helper function near the top of the component
  const validateRating = (value) => {
    // Only allow letters and specific special characters (like +, -)
    return value.replace(/[^A-Za-z+-]/g, "");
  };

  // Add this validation helper function near the top of the component
  const validateISIN = (value) => {
    // Remove any spaces or special characters
    const cleanValue = value.replace(/[^A-Z0-9]/g, "");

    // Limit to 12 characters
    return cleanValue.slice(0, 12);
  };

  // Add this validation check function
  const isValidISIN = (isin) => {
    // Basic format check: 12 characters, first 2 must be letters
    const isinRegex = /^[A-Z]{2}[A-Z0-9]{9}[0-9]$/;
    return isinRegex.test(isin);
  };

  // Add validation helper functions
  const validateBondName = (value) => {
    // Only allow letters, numbers, and spaces
    return value.replace(/[^a-zA-Z0-9\s]/g, "");
  };

  const validateNumericField = (value) => {
    // Only allow numbers and decimal point
    return value.replace(/[^0-9.]/g, "");
  };

  const validateAlphaNumeric = (value) => {
    // Only allow letters and numbers (no spaces)
    return value.replace(/[^a-zA-Z0-9]/g, "");
  };

  const validateAlphaOnly = (value) => {
    // Only allow letters and spaces
    return value.replace(/[^a-zA-Z\s]/g, "");
  };

  // Add this validation helper near the top with other validation functions
  const validateFutureDate = (selectedDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time portion for accurate date comparison
    const inputDate = new Date(selectedDate);
    return inputDate >= today;
  };

  // Modify the handleInputChange function
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let validatedValue = value;

    // Apply specific validation based on field name
    switch (name) {
      case "issuerName":
      case "securityName":
      case "isinDescription":
      case "debantureTrustee":
        validatedValue = validateBondName(value);
        break;
      case "issueType":
      case "industry":
      case "ratingAgency":
        validatedValue = validateAlphaOnly(value);
        break;
      case "coupenRate":
      case "currentYeild":
      case "faceValue":
        validatedValue = validateNumericField(value);
        break;
      case "isin":
        validatedValue = validateISIN(value.toUpperCase());
        break;
      case "rating":
        validatedValue = validateRating(value);
        break;
      case "coupenBasis":
      case "coupenFrequency":
        validatedValue = validateAlphaOnly(value);
        break;
      case "dateOfMaturity":
        // Only update if it's a future date or empty
        if (!value || validateFutureDate(value)) {
          validatedValue = value;
        } else {
          // Return early without updating if invalid date
          return;
        }
        break;
      default:
        // For checkbox or other types, keep original value
        validatedValue = type === "checkbox" ? checked : value;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: validatedValue,
    }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value === "yes",
    }));
  };

  const handleSelectChangeMultiple = (name, value) => {
    alert(name);
  };

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      [fileType]: file,
    }));
  };
  console.log("formdata", formData);

  const saveBond = () => {
    setFormData((prev) => ({
      ...prev,
      secured,
      listed,
      liquidityRisk: liquiedRisk,
      senior,
      fraudRisk,
      creditRisk,
      // bondDetailsDocument:selectedFile,
      // imDocument:selectedPan,
      // logo:selectedAadhar
    }));
    updateBondDetails();
  };

  // Update both ytm and formData.coupenRate when YTM input changes
  const handleYtmChange = (e) => {
    const validValue = validateNumericField(e.target.value);
    setYtm(validValue);
    setFormData((prev) => ({
      ...prev,
      coupenRate: validValue,
    }));
  };

  // Update the name handler
  const handleNameChange = (e) => {
    const validValue = validateBondName(e.target.value);
    setName(validValue);
  };

  const handleFreqChange = (e) => {
    const validValue = validateAlphaOnly(e.target.value);
    setFreq(validValue);
  };

  const handleMinInvestChange = (e) => {
    const validValue = validateNumericField(e.target.value);
    setMinInvest(validValue);
  };

  const handleMaturityChange = (e) => {
    const validValue = validateNumericField(e.target.value);
    setMat(validValue);
  };

  return (
    <div className="w-full mt-[60px] ml-4">
      <div>
        <button
          onClick={() => navigate("/bond")}
          className="border-none bg-transparent text-gray-700 text-sm font-bold cursor-pointer py-2.5"
        >
          ← Back
        </button>
      </div>
      <div className="bg-white rounded-lg pt-6 mt-3 border border-1 border-gray-300">
        <h2 className="text-lg font-medium px-5">Edit Bond</h2>
        <div className="border-b border-1 border-gray-300 pb-2"></div>

        {/* First Row */}
        <div className="flex flex-wrap gap-6 px-5 pt-5">
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Bond Name
            </label>
            <input
              type="text"
              value={name}
              onChange={handleNameChange}
              placeholder="Enter Name"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">YTM(%)</label>
            <input
              type="text"
              value={ytm}
              onChange={handleYtmChange}
              placeholder="Enter YTM"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Frequency
            </label>
            <input
              type="text"
              placeholder="Enter Frequency"
              value={freq}
              onChange={handleFreqChange}
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Min Investment(₹)
            </label>
            <input
              type="text"
              value={minIvest}
              onChange={handleMinInvestChange}
              placeholder="₹ xxx,xxx"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Maturity(Months)
            </label>
            <input
              type="text"
              value={mat}
              onChange={handleMaturityChange}
              placeholder="Enter Maturity"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
        </div>

        {/* Fundamental Details Section */}
        <h3 className="text-md font-medium mb-4 mt-10 px-5">
          Fundamental Details
        </h3>
        <div className="flex flex-wrap gap-6 mb-6 px-5">
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Issuer Name
            </label>
            <input
              type="text"
              name="issuerName"
              value={formData?.issuerName || ""}
              onChange={handleInputChange}
              placeholder="Issuer Name"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Issue Type
            </label>
            <input
              type="text"
              name="issueType"
              value={formData?.issueType || ""}
              onChange={handleInputChange}
              placeholder="Enter Issue Type"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Coupon Rate(%)
            </label>
            <input
              type="text"
              name="coupenRate"
              value={formData?.coupenRate || ""}
              onChange={handleInputChange}
              placeholder="Enter Coupon Rate"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Current Yield(%)
            </label>
            <input
              type="number"
              name="currentYeild"
              value={formData?.currentYeild || ""}
              onChange={handleInputChange}
              placeholder="Enter Current Yield"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Coupon Basis
            </label>
            <input
              type="text"
              name="coupenBasis"
              value={formData?.coupenBasis || ""}
              onChange={handleInputChange}
              placeholder="Fixed Interest"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Coupon Freq
            </label>
            <input
              type="text"
              name="coupenFrequency"
              value={formData?.coupenFrequency || ""}
              onChange={handleInputChange}
              placeholder="Monthly"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">Industry</label>
            <input
              type="text"
              name="industry"
              value={formData?.industry || ""}
              onChange={handleInputChange}
              placeholder="Enter Industry"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Face Value(₹)
            </label>
            <input
              type="number"
              name="faceValue"
              value={formData?.faceValue || ""}
              onChange={handleInputChange}
              placeholder="Enter Value"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
              required
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2 cursor-pointer">
              Date of Maturity
            </label>
            <input
              type="date"
              name="dateOfMaturity"
              value={
                formData?.dateOfMaturity
                  ? formData.dateOfMaturity.split("T")[0]
                  : ""
              }
              onChange={handleInputChange}
              min={new Date().toISOString().split("T")[0]} // Set minimum date to today
              placeholder="Select Date"
              className={`w-full h-10 p-2.5 border-none rounded ${
                formData?.dateOfMaturity &&
                !validateFutureDate(formData.dateOfMaturity)
                  ? "bg-red-50"
                  : "bg-gray-50"
              }`}
              required
            />
            {formData?.dateOfMaturity &&
              !validateFutureDate(formData.dateOfMaturity) && (
                <small className="text-red-500">
                  Please select a future date
                </small>
              )}
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">ISIN</label>
            <input
              type="text"
              name="isin"
              value={formData?.isin || ""}
              onChange={handleInputChange}
              placeholder="Enter ISIN (e.g., IN0000000001)"
              className={`w-full h-10 p-2.5 border-none rounded ${
                formData?.isin && !isValidISIN(formData.isin)
                  ? "bg-red-50"
                  : "bg-gray-50"
              }`}
            />
            {formData?.isin && !isValidISIN(formData.isin) && (
              <small className="text-red-500">
                Must be 12 characters: 2 letters followed by 9 alphanumeric
                characters and 1 number
              </small>
            )}
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              ISIN description
            </label>
            <input
              type="text"
              name="isinDescription"
              value={formData?.isinDescription || ""}
              onChange={handleInputChange}
              placeholder="Enter ISIN description"
              className={`w-full h-10 p-2.5 border-none rounded`}
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Debenture Trustee
            </label>
            <input
              type="text"
              name="debantureTrustee"
              value={formData?.debantureTrustee}
              onChange={handleInputChange}
              placeholder="Enter Trustee"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Security Name
            </label>
            <input
              type="text"
              name="securityName"
              value={formData?.securityName}
              onChange={handleInputChange}
              placeholder="Enter Security Name"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
        </div>

        {/* Rating Details Section */}
        <h3 className="text-md font-medium mb-4 mt-10 px-5">Rating Details</h3>
        <div className="flex flex-wrap gap-6 mb-6 px-5">
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Rating Agency
            </label>
            <input
              type="text"
              name="ratingAgency"
              value={formData?.ratingAgency || ""}
              onChange={handleInputChange}
              placeholder="Enter Rating Agency"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">Rating</label>
            <input
              type="text"
              name="rating"
              value={formData?.rating || ""}
              onChange={handleInputChange}
              placeholder="Enter Rating (letters only, e.g. AAA)"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
            <small className="text-gray-500">
              Only letters and +/- symbols allowed (e.g. AAA, AA+, BBB-)
            </small>
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">Rated On</label>
            <input
              type="date"
              name="ratedOn"
              value={formData?.ratedOn ? formData.ratedOn.split("T")[0] : ""}
              onChange={handleInputChange}
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
            />
          </div>
        </div>

        {/* Other Information Section */}
        <h3 className="text-md font-medium mb-4 mt-10 px-5">
          Other Information
        </h3>
        <div className="flex flex-wrap gap-6 mb-6 px-5">
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Handpicked
            </label>
            {/* <select
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
              value={formData?.handPicked ? "yes" : "no"}
            >
              name="" onChange={handleInputChange}
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select> */}

            <div className="w-full">
              <SelectButtonV2
                placeholder="select"
                options={optionsShow}
                selectedValue={formData.handPicked ? "yes" : "no"}
                // onSelect={handleSelectOccupation}
                onSelect={(value) => handleSelectChange("handPicked", value)}
              />
            </div>
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">Popular</label>
            {/* <select
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
              value={formData?.popular ? "yes" : "no"}
            >
              name="popular" onChange={handleInputChange}
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select> */}

            <div className="w-full">
              <SelectButtonV2
                placeholder="select"
                options={optionsShow}
                selectedValue={formData.popular ? "yes" : "no"}
                // onSelect={handleSelectOccupation}
                onSelect={(value) => handleSelectChange("popular", value)}
              />
            </div>
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-600 text-sm block mb-2">
              Highly Rated
            </label>
            {/* <select
              className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
              value={formData?.highRated ? "yes" : "no"}
            >
              name="highRated" onChange={handleInputChange}
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select> */}

            <div className="w-full">
              <SelectButtonV2
                placeholder="select"
                options={optionsShow}
                selectedValue={formData.highRated ? "yes" : "no"}
                // onSelect={handleSelectOccupation}
                onSelect={(value) => handleSelectChange("highRated", value)}
              />
            </div>
          </div>
        </div>

        {/* Quality & Risk Details */}
        <div className="flex flex-wrap gap-6 mb-6 mt-10 px-5">
          <div className="flex-1 min-w-[300px]">
            <h3 className="text-md font-medium mb-4">Quality Details</h3>
            <div className="flex gap-4">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className={`mr-2 rounded focus:outline-none ${
                    secured ? "focus:ring-50" : "focus:ring-0"
                  }`}
                  checked={secured}
                  onChange={() => setSecured(!secured)}
                />
                Secured
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className={`mr-2 rounded focus:outline-none ${
                    senior ? "focus:ring-50" : "focus:ring-0"
                  }`}
                  checked={senior}
                  onChange={() => setSenior(!senior)}
                />
                Senior
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className={`mr-2 rounded focus:outline-none ${
                    listed ? "focus:ring-50" : "focus:ring-0"
                  }`}
                  checked={listed}
                  onChange={() => setListed(!listed)}
                />
                Listed
              </label>
            </div>
          </div>
          <div className="flex-1 min-w-[300px]">
            <h3 className="text-md font-medium mb-4">Risk Details</h3>
            <div className="flex gap-4">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className={`mr-2 rounded focus:outline-none ${
                    liquiedRisk ? "focus:ring-50" : "focus:ring-0"
                  }`}
                  checked={liquiedRisk}
                  onChange={() => setLiquiedRisk(!liquiedRisk)}
                />
                Liquidity Risk
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className={`mr-2 rounded focus:outline-none ${
                    creditRisk ? "focus:ring-50" : "focus:ring-0"
                  }`}
                  checked={creditRisk}
                  onChange={() => setCreditRisk(!creditRisk)}
                />
                Credit Risk
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className={`mr-2 rounded focus:outline-none ${
                    fraudRisk ? "focus:ring-50" : "focus:ring-0"
                  }`}
                  checked={fraudRisk}
                  onChange={() => setFraudRisk(!fraudRisk)}
                />
                Fraud Risk
              </label>
            </div>
          </div>
        </div>

        {/* Related Documents */}
        <h3 className="text-lg font-medium mb-4 mt-10 px-5">
          Related Document
        </h3>
        <div className="flex flex-wrap gap-6 mb-8 px-5">
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-700 text-sm block mb-2">
              IM Document
            </label>
            <label className="cursor-pointer">
              <input
                type="file"
                className="hidden"
                onChange={handlePImChange}
              />
              <div className="bg-gray-50 rounded p-2.5 flex items-center justify-between">
                <div className="flex items-center gap-2 text-gray-500">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <span>
                    {selectedFile
                      ? selectedFile.name
                      : bondDetails?.imDocument
                      ? bondDetails.imDocument.split("/").pop()
                      : "Choose File"}
                  </span>
                </div>
                {bondDetails?.imDocument && !selectedFile && (
                  <a
                    href={`${base_url}${bondDetails.imDocument}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="w-5 h-5 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0l-4 4m4-4v12"
                      />
                    </svg>
                  </a>
                )}
              </div>
            </label>
          </div>
          <div className="flex-1 min-w-[250px]">
            <label className="text-gray-700 text-sm block mb-2">
              Bond Details Document
            </label>
            <label className="cursor-pointer">
              <input type="file" className="hidden" onChange={handleBdChange} />
              <div className="bg-gray-50 rounded p-2.5 flex items-center justify-between">
                <div className="flex items-center gap-2 text-gray-500">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <span>
                    {selectedPan
                      ? selectedPan.name
                      : bondDetails?.bondDetailsDocument
                      ? bondDetails.bondDetailsDocument.split("/").pop()
                      : "Choose File"}
                  </span>
                </div>
                {bondDetails?.bondDetailsDocument && !selectedPan && (
                  <a
                    href={`${base_url}${bondDetails.bondDetailsDocument}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="w-5 h-5 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0l-4 4m4-4v12"
                      />
                    </svg>
                  </a>
                )}
              </div>
            </label>
          </div>
        </div>

        {/* Image Upload */}
        <h3 className="text-lg font-medium mb-4 mt-10 px-5">Image</h3>
        <div className="flex-1 min-w-[250px]">
          <div className="mb-8 px-5">
            <label className="text-gray-700 text-sm block mb-2">Logo</label>
            <label className="cursor-pointer">
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={handleLogoChange}
              />
              <div className="bg-gray-50 rounded p-2.5 flex items-center justify-between max-w-[48.5%]">
                <div className="flex items-center gap-2 text-gray-500">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <span>
                    {selectedAadhar
                      ? selectedAadhar.name
                      : bondDetails?.logo
                      ? bondDetails.logo.split("/").pop()
                      : "Choose File"}
                  </span>
                </div>
                {bondDetails?.logo && !selectedAadhar && (
                  <a
                    href={`${base_url}${bondDetails.logo}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="w-5 h-5 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0l-4 4m4-4v12"
                      />
                    </svg>
                  </a>
                )}
              </div>
            </label>
          </div>
        </div>
        {/* Add Investor */}
        <h3 className="text-lg font-medium mb-4 mt-10 px-5">Add Investor</h3>
        <div className="flex-1 min-w-[250px]">
          <div className="mb-8 px-5">
            <div className="w-[60%]">
              <Repeater
                rows={rows}
                setRows={setRows}
                bondDetails={bondDetails}
              />
            </div>
          </div>
        </div>
      </div>{" "}
      {/* Action Buttons */}
      <div className="flex justify-end gap-4 m-5">
        <button
          className="px-6 py-2 border border-gray-300 rounded-[10px]"
          onClick={() => navigate("/bond")}
        >
          Cancel
        </button>
        <button
          onClick={saveBond}
          className="px-6 py-2 bg-[#0066b2] text-white rounded-[10px]"
        >
          Save Bond
        </button>
      </div>
    </div>
  );
};

export default BondListEdit;
